import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { Language, LanguageLevel, CacheService } from 'mapfre-auditlib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  className = 'LanguageService'

  sections = [
    'administration'
  ]

  constructor(private http: HttpClient, private cacheService: CacheService, private router: Router) { }

  getAllLanguages(cache = true): Observable<Language[]> | any{ 
    const isAdminSection = _.some(this.sections, section => _.includes(this.router.url, section));
    let cacheKey = 'allLanguages'+"_"+isAdminSection.toString()
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<any[]>(environment.base_URL + "/languages").pipe(map((res) => {
         if(isAdminSection){
            this.cacheService.updateCacheData(res, cacheKey)
            return res;
         }else{
            let filtrado =  _.filter(res, it => it.mrkActive && it.idLanguagePk != 3 && it.idLanguagePk != 4 && it.idLanguagePk != 5);
            this.cacheService.updateCacheData(filtrado, cacheKey)
            return filtrado;
         }
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
   }
  }

  getAllLanguagesNoAutoID(): Observable<Language[]> {
    return this.http.get<Language[]>(environment.base_URL + "/languages").pipe(map<Language[], Language[]>(res => this.removeById(res)));
  }

  removeById(array) {
    array.forEach(element => {
      delete element.id;
    });
    return array;
  }

  getAllLangByProps(propierties) {
    return this.getAllLanguages().pipe(map<any[], any>(res => {
      return _.map(res, _.partialRight(_.pick, propierties));
    }))
  }

  newLanguage(language) {
    return this.http.post(environment.base_URL + "/languages", language)
  }

  updateLanguage(language, id) {
    return this.http.put(environment.base_URL + `/languages/${id}`, language)
  }

  deleteLanguage(id) {
    return this.http.delete(environment.base_URL + `/languages/${id}`)
  }

  /**
   *  Language Level
   */


  getAllLanguageLevels(cache = true, cacheKey = "allLanguageLevels"): any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<LanguageLevel[]>(environment.base_URL + "/types-level-language").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
  newLanguageLevel(level) {
    return this.http.post(environment.base_URL + "/types-level-language", level)
  }

  updateLanguageLevel(level, id) {
    return this.http.put(environment.base_URL + `/types-level-language/${id}`, level)
  }

  /**
   * Delete Cache
   */

  deleteCache() {

    let memoryCache = ["allLanguages"];

    _.forEach(memoryCache, item => {
      this.cacheService.deleteCache(item);
    })

  }
}